import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

export default async ({ Vue }) => {
  const bugsnagClient = bugsnag({
    apiKey: process.env.BUGSNAG_API_KEY,
    appVersion: `${process.env.VERSION}-${process.env.NODE_ENV}-${process.env.PLATFORM}`,
    releaseStage: process.env.NODE_ENV,
    notifyReleaseStages: ['production', 'staging'],
  });

  bugsnagClient.use(bugsnagVue, Vue);
  // bugsnagClient.notify(new Error('Test error'));

  Vue.prototype.$bugsnag = bugsnagClient;
};
